import { USER_ROLES } from "@/constants";
import { mspRoutes as phishTitanMspRoutes } from "@/modules/PhishTitan/routes/mspRoutes";
import { mspSettingsRoutes } from "@/modules/Settings/routes/mspRoutes";
import { mspRoutes as arcTitanMspRoutes } from "@/modules/ArcTitan/routes/mspRoutes";
import { mspRoutes as reportManagerMspRoutes } from "@/modules/ReportManager/routes/mspRoutes";

const mspRoutes = [
  {
    path: "",
    name: "msp-root-index",
    redirect: {
      name: "msp-dashboard",
    },
    exact: false,
    meta: {
      authorize: [USER_ROLES.SYSTEM, USER_ROLES.SALES, USER_ROLES.MSP],
    },
  },
  {
    path: "dashboard",
    exact: false,
    name: "msp-dashboard",
    component: () => import("@/modules/Dashboard/views/Msp/index.vue"),
  },
  {
    path: "customers",
    exact: false,
    name: "mspOverview",
    component: () => import("@/modules/Customers"),
  },
  {
    path: ":id/customers",
    name: "msp-customers",
    component: () => import("@/modules/Customers"),
  },
  // PhishTitan MSP routes (email security etc.)
  ...phishTitanMspRoutes.children,
  // ArcTitan MSP routes (email archiving)
  ...arcTitanMspRoutes.children,
  // ReportManager MSP routes
  ...reportManagerMspRoutes.children,
  // Settings module routes
  ...mspSettingsRoutes,
];
export default mspRoutes;
